import { create } from 'zustand';
import { Habit } from '../dto/habit';
import { Partnership } from '../dto/partnership';
import { DailyReading } from '../dto/reading';
import { Record } from '../dto/record';
import { DailyStatistics } from '../dto/statistics';
import { UserReading } from '../dto/user-reading';

interface DataState {
  habits: Habit[] | undefined;
  setHabits: (habits: Habit[] | undefined) => void;
  records: Record[] | undefined;
  setRecords: (records: Record[] | undefined) => void;
  partnerships: Partnership[] | undefined;
  setPartnerships: (partnerships: Partnership[] | undefined) => void;
  dailyReading: DailyReading | undefined;
  setDailyReading: (reading: DailyReading | undefined) => void;
  completedReadings: UserReading[] | undefined;
  setCompletedReadings: (readings: UserReading[] | undefined) => void;
  statistics: DailyStatistics[] | undefined;
  setStatistics: (statistics: DailyStatistics[] | undefined) => void;
}

export const useDataStore = create<DataState>()((set) => ({
  habits: undefined,
  setHabits: (habits: Habit[] | undefined) => set(() => ({ habits })),
  records: undefined,
  setRecords: (records: Record[] | undefined) => set(() => ({ records })),
  partnerships: undefined,
  setPartnerships: (partnerships: Partnership[] | undefined) => set(() => ({ partnerships })),
  dailyReading: undefined,
  setDailyReading: (dailyReading: DailyReading | undefined) => set(() => ({ dailyReading })),
  completedReadings: undefined,
  setCompletedReadings: (completedReadings: UserReading[] | undefined) => set(() => ({ completedReadings })),
  statistics: undefined,
  setStatistics: (statistics: DailyStatistics[] | undefined) => set(() => ({ statistics })),
}));
